import ScrollLockModal from 'shared/ScrollLockModal'
import useUnmarkAsPurchased from 'src/routes/(registry)/registry/(gift-tracker-revamp)/hooks/useUnmarkAsPurchased/useUnmarkAsPurchased'
import useGetRegistry from 'src/routes/(subdomains)/(my)/[slug]/hooks/useGetRegistry'
import ResponsiveButton from './components/ResponsiveButton'
import css from './UnmarkPurchaseModal.styles.scss'
import { UnmarkPurchasedModalProps } from './UnmarkPurchasedModal.types'

const UnmarkPurchaseModal = ({
  children,
  handleClose,
  handleDismount,
  isOpen,
  onUnmarkedAsPurchased,
  reservation,
}: UnmarkPurchasedModalProps) => {
  const { registry } = useGetRegistry(reservation.registryId.toString())
  const {
    ctaText,
    isLoading,
    mutate: unmarkPurchase,
  } = useUnmarkAsPurchased({
    registry,
    reservation,
    onSuccess: onUnmarkedAsPurchased,
  })

  const handleUnmarkPurchase = () => unmarkPurchase()

  const unmarkButton = (
    <ResponsiveButton
      loading={isLoading}
      variant="destructive"
      onClick={handleUnmarkPurchase}
    >
      {ctaText}
    </ResponsiveButton>
  )

  const cancelButton = (
    <ResponsiveButton variant="secondary" onClick={() => handleClose()}>
      Cancel
    </ResponsiveButton>
  )

  return (
    <ScrollLockModal
      showCloseButton
      handleClose={handleClose}
      handleDismount={handleDismount}
      isOpen={isOpen}
      primaryButton={unmarkButton}
      secondaryButton={cancelButton}
      title={ctaText}
    >
      <div className={css.UnmarkPurchaseModal}>{children}</div>
    </ScrollLockModal>
  )
}

export default UnmarkPurchaseModal
